module.exports = __webpack_public_path__ + "img/C08TechAshokasWrathRM_ua.ef6775df.webp";